import { useGetMe } from '@shared/services/get-me';

import type { TEntity } from '@shared/constants/entities';
import type { PermissionAction } from '@src/features/roles/types';

export function useHasPermission() {
  const { data: member } = useGetMe();
  const permissions = member?.role?.permissions || [];

  const hasPermission = (
    entity: TEntity | TEntity[],
    action: PermissionAction | PermissionAction[]
  ) => {
    if (member?.is_owner) return true;

    if (!entity || !permissions.length) return false;

    const entities = Array.isArray(entity) ? entity : [entity];
    const actions = Array.isArray(action) ? action : [action];

    const permissionCodeNames = permissions.map((p) => p.codename);

    return entities.every((currentEntity) =>
      actions.every((currentAction) =>
        permissionCodeNames.includes(`${currentAction}_${currentEntity}`)
      )
    );
  };

  return hasPermission;
}
